__turbopack_context__.v({
  "grid": "CardsGrid-module-scss-module__bYgmka__grid",
});
